import { reduxForm } from 'redux-form'
import { goBack } from 'react-router-redux'

import { signOffOnWorkOrder } from '../../actions/work-orders'

import WorkSummarySignOff from '../../components/work-summaries/work-summary-sign-off'

const fields = [
  'typedSignature'
]

function mapStateToProps (state, ownProps) {
  const name = state.auth.session.userName

  return {
    modalTitle: 'Sign off',
    initialValues: {
      typedSignature: name
    }
  }
}

function mapDispatchToProps (dispatch, ownProps) {
  return {
    onSubmit (data) {
      return dispatch(signOffOnWorkOrder(ownProps.params.workSummaryId, data))
        .then((action) => {
          if (action.error) {
            const { payload: { errors: [{ detail: _error }] } } = action
            return Promise.reject({ _error })
          } else {
            dispatch(goBack())
          }
        })
    },

    handleClose () {
      dispatch(goBack())
    }
  }
}

export default reduxForm(
  {
    fields,
    form: 'workSummarySignOff'
  },
  mapStateToProps,
  mapDispatchToProps
)(WorkSummarySignOff)



// WEBPACK FOOTER //
// ./src/containers/work-summaries/work-summary-sign-off-container.js